
function gtag(){
  window.dataLayer?.push(arguments);
}

function initializeGtag(id) {
  if ((id?.length || 0) === 0) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', id);

  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(scriptTag);
}

export {
  initializeGtag,
  gtag
};
